export default {"src":"/_next/static/media/Anz-color.ffbab323.svg","height":31,"width":96};